import React from 'react';

import { Box } from '@rover/kibble/core';

import { DIALOG_START_PROPS } from '../Modal.common';

import type { Props } from './TitleFocusTarget.common';

/** VoiceOver doesn't follow focus to the dialog itself, so screen readers start on the title. */
export default function TitleFocusTarget({ fill, children }: Props): React.ReactNode {
  return (
    <Box
      flex={fill ? '1' : undefined}
      webProps={DIALOG_START_PROPS}
      sx={{ '&[tabindex="-1"]:focus': { outline: 'none' } }}
    >
      {children}
    </Box>
  );
}
